import {createApi} from '@reduxjs/toolkit/query/react'
import {baseQueryWithReAuth} from "@/store/features/baseRtkQuery";
import {AgentCreationResponse} from "@/services/models/agentCreationResponse";
import type {IconName} from '@/app/components/icon-picker/icon-picker.types';
import {agentsApiSlice} from '@/store/features/agents/agentsApiSlice';
import {AgentCollection} from "@/app/agents/agent-creation/page";

export const agentCreationApiSlice = createApi({
    reducerPath: 'agentCreationApi',
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        postNewAgent: builder.mutation<AgentCreationResponse[], AgentCollection>({
            query: ({
                        agentId,
                        name,
                        description,
                        systemPrompt,
                        llmModel,
                        temperature,
                        responseFormat,
                        seed,
                        reasoningEffort,
                        collectionUuid,
                        tools,
                        tags,
                        userIds,
                        groupIds,
                        icon,
                        isblocked,
                        promptSuggestions
                    }) => ({
                url: `Agent`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: {
                    agentId,
                    name,
                    description,
                    systemPrompt,
                    llmModel,
                    temperature,
                    responseFormat,
                    seed,
                    reasoningEffort,
                    collectionUuid,
                    tools,
                    tags,
                    userIds,
                    groupIds,
                    icon,
                    isblocked,
                    promptSuggestions,
                },
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                try {
                    await queryFulfilled;
                    dispatch(agentsApiSlice.util.invalidateTags([{type: 'Agents', id: 'LIST'}]));
                } catch {
                }
            },
        }),
    }),
})

const {
    usePostNewAgentMutation
} = agentCreationApiSlice
export const agentCreationApiActions = {
    usePostNewAgentMutation,
}